(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection) return;

    const freeShippingThreshold = parseInt(cartSection.dataset.freeShippingThreshold, 10) || 0;

    const formatMoney = (cents) => {
      const amount = (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return '₹ ' + amount;
    };

    const updateCartTotals = (cartData) => {
      // Update badge counts in header
      const badges = document.querySelectorAll('.header__cart-badge');
      badges.forEach((b) => {
        b.textContent = cartData.item_count;
      });

      // Update cart title count
      const countEl = cartSection.querySelector('[data-cart-item-count]');
      if (countEl) countEl.textContent = `(${cartData.item_count})`;

      // Update Subtotal & Total
      const subtotalEl = cartSection.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cartData.original_total_price);

      const totalEl = cartSection.querySelector('[data-cart-total]');
      if (totalEl) totalEl.textContent = formatMoney(cartData.total_price);

      // If cart empty, reload to show empty state
      if (cartData.item_count === 0) {
        window.location.reload();
      }
    };

    const changeQuantity = async (itemKey, quantity, itemRow) => {
      if (itemRow) itemRow.classList.add('is-updating');

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: quantity,
          }),
        });

        const cartData = await response.json();

        if (response.ok) {
          if (quantity === 0) {
            if (itemRow) itemRow.remove();
          } else {
            const updatedItem = cartData.items.find((it) => it.key === itemKey);
            if (updatedItem && itemRow) {
              const linePriceEl = itemRow.querySelector('[data-line-price]');
              if (linePriceEl) linePriceEl.textContent = formatMoney(updatedItem.final_line_price);
              const inputs = itemRow.querySelectorAll('[data-qty-input]');
              inputs.forEach((input) => {
                input.value = updatedItem.quantity;
              });
            }
          }
          updateCartTotals(cartData);
        }
      } catch (err) {
        console.error('Error updating cart', err);
      } finally {
        if (itemRow) itemRow.classList.remove('is-updating');
      }
    };

    // Stepper Button Listeners
    cartSection.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-btn]');
      if (btn) {
        e.preventDefault();
        const stepper = btn.closest('.cart-qty-stepper');
        const input = stepper.querySelector('[data-qty-input]');
        const itemRow = btn.closest('[data-cart-item]');
        const itemKey = input.dataset.itemKey;
        let currentQty = parseInt(input.value, 10) || 0;

        if (btn.dataset.qtyBtn === 'plus') {
          currentQty += 1;
        } else if (btn.dataset.qtyBtn === 'minus') {
          currentQty = Math.max(0, currentQty - 1);
        }

        input.value = currentQty;
        changeQuantity(itemKey, currentQty, itemRow);
        return;
      }

      const removeBtn = e.target.closest('[data-remove-item]');
      if (removeBtn) {
        e.preventDefault();
        const itemKey = removeBtn.dataset.itemKey;
        const itemRow = removeBtn.closest('[data-cart-item]');
        changeQuantity(itemKey, 0, itemRow);
      }
    });

    // Input Change Listeners
    cartSection.addEventListener('change', (e) => {
      const input = e.target.closest('[data-qty-input]');
      if (input) {
        const itemRow = input.closest('[data-cart-item]');
        const itemKey = input.dataset.itemKey;
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeQuantity(itemKey, qty, itemRow);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-section-type="collection"]');
    if (!section) return;

    // 1. Grid Column Switcher (3 vs 4 columns on desktop)
    const grid = section.querySelector('[data-collection-grid]');
    const layoutBtns = section.querySelectorAll('[data-grid-cols]');

    layoutBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const cols = btn.getAttribute('data-grid-cols');
        if (!grid) return;

        grid.classList.remove('collection-grid--cols-3', 'collection-grid--cols-4');
        grid.classList.add('collection-grid--cols-' + cols);

        layoutBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        try {
          localStorage.setItem('saree_collection_cols', cols);
        } catch (e) {}
      });
    });

    // Restore saved grid preference
    try {
      const savedCols = localStorage.getItem('saree_collection_cols');
      if (savedCols && grid) {
        const targetBtn = section.querySelector(`[data-grid-cols="${savedCols}"]`);
        if (targetBtn) targetBtn.click();
      }
    } catch (e) {}

    // 2. Slide-out Filter Drawer
    const drawer = section.querySelector('[data-filter-drawer]');
    const openBtn = section.querySelector('[data-filter-drawer-open]');
    const closeBtns = section.querySelectorAll('[data-filter-drawer-close]');

    const openDrawer = () => {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    if (openBtn) {
      openBtn.addEventListener('click', openDrawer);
    }

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Auto submit on sort dropdown change
    const sortSelect = section.querySelector('[data-sort-by-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const form = sortSelect.closest('form');
        if (form) form.submit();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class FeaturedCollectionSlider {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-slider-track]');
      this.prevBtn = section.querySelector('[data-slider-prev]');
      this.nextBtn = section.querySelector('[data-slider-next]');
      this.dotsContainer = section.querySelector('[data-slider-dots]');

      this.isDesktopSlider = section.getAttribute('data-desktop-slider') === 'true';
      this.isMobileSlider = section.getAttribute('data-mobile-slider') === 'true';
      this.enableAutoplay = section.getAttribute('data-autoplay') === 'true';
      this.autoplayInterval = (parseInt(section.getAttribute('data-autoplay-interval'), 10) || 4) * 1000;
      this.autoplayTimer = null;
      this.animationFrameId = null;
      this.dots = [];

      if (!this.track) return;

      this.init();
    }

    init() {
      if (this.prevBtn && this.nextBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.scroll(-1);
          this.restartAutoplay();
        });
        this.nextBtn.addEventListener('click', () => {
          this.scroll(1);
          this.restartAutoplay();
        });
      }

      this.track.addEventListener('scroll', () => this.handleScroll(), { passive: true });

      // Setup sluggish touch swipe & mouse dragging
      this.setupMouseDrag();
      this.setupTouchSwipe();
      this.setupDots();

      if (this.enableAutoplay) {
        this.startAutoplay();
        this.track.addEventListener('mouseenter', () => this.stopAutoplay());
        this.track.addEventListener('mouseleave', () => this.restartAutoplay());

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.startAutoplay();
                } else {
                  this.stopAutoplay();
                }
              });
            },
            { threshold: 0.1 }
          );
          observer.observe(this.section);
        }
      }

      this.handleScroll();

      // Recalculate on window resize
      window.addEventListener(
        'resize',
        () => {
          this.setupDots();
          this.handleScroll();
        },
        { passive: true }
      );
    }

    getCardMetrics() {
      const items = this.track.querySelectorAll('[data-slider-item]');
      if (!items.length) return { itemWidth: 300, stride: 300, totalItems: 0, gap: 12, maxScroll: 0 };
      const firstItem = items[0];
      const itemWidth = firstItem.offsetWidth;
      let gap = 12;
      if (items.length > 1) {
        const computedGap = items[1].offsetLeft - (items[0].offsetLeft + items[0].offsetWidth);
        if (computedGap > 0) {
          gap = computedGap;
        } else {
          gap = parseFloat(window.getComputedStyle(this.track).gap) || 12;
        }
      }
      const stride = itemWidth + gap;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      return { itemWidth, stride, totalItems: items.length, gap, maxScroll };
    }

    /* Luxurious Sluggish Smooth Scroll Engine (Quintic Easing) */
    smoothScrollTo(targetLeft, duration = 900) {
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }

      const { maxScroll } = this.getCardMetrics();
      const clampedTarget = Math.max(0, Math.min(targetLeft, maxScroll));
      const startLeft = this.track.scrollLeft;
      const distance = clampedTarget - startLeft;

      if (Math.abs(distance) < 1) {
        this.track.scrollLeft = clampedTarget;
        this.handleScroll();
        return;
      }

      // Temporarily disable CSS scroll-snap so browser doesn't jerk
      this.track.style.scrollSnapType = 'none';
      this.track.style.scrollBehavior = 'auto';

      const startTime = performance.now();

      // Silky sluggish deceleration curve: easeOutQuart / quintic curve
      const easeOutSluggish = (t) => 1 - Math.pow(1 - t, 3.8);

      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = easeOutSluggish(progress);

        this.track.scrollLeft = startLeft + distance * easedProgress;

        if (progress < 1) {
          this.animationFrameId = requestAnimationFrame(step);
        } else {
          this.track.scrollLeft = clampedTarget;
          this.animationFrameId = null;
          this.track.style.scrollSnapType = '';
          this.handleScroll();
        }
      };

      this.animationFrameId = requestAnimationFrame(step);
    }

    setupMouseDrag() {
      const track = this.track;
      let isDown = false;
      let startX = 0;
      let scrollStart = 0;
      let startTime = 0;
      let hasDragged = false;

      track.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
        }
        this.stopAutoplay();

        isDown = true;
        hasDragged = false;
        startX = e.pageX;
        scrollStart = track.scrollLeft;
        startTime = performance.now();
        track.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
      });

      window.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const diffX = e.pageX - startX;
        if (Math.abs(diffX) > 4) {
          hasDragged = true;
        }
        track.scrollLeft = scrollStart - diffX;
      });

      const endMouseDrag = (e) => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');

        if (hasDragged) {
          const diffX = e.pageX - startX;
          const duration = Math.max(1, performance.now() - startTime);
          const velocity = diffX / duration;
          const { stride, maxScroll } = this.getCardMetrics();

          let targetIndex;
          if (velocity < -0.22 || diffX < -stride * 0.18) {
            targetIndex = Math.ceil((scrollStart + 10) / stride);
          } else if (velocity > 0.22 || diffX > stride * 0.18) {
            targetIndex = Math.floor((scrollStart - 10) / stride);
          } else {
            targetIndex = Math.round(track.scrollLeft / stride);
          }

          const targetScroll = Math.max(0, Math.min(targetIndex * stride, maxScroll));
          this.smoothScrollTo(targetScroll, 880);
        } else {
          track.style.scrollSnapType = '';
        }

        this.restartAutoplay();
      };

      window.addEventListener('mouseup', endMouseDrag);

      track.addEventListener(
        'click',
        (e) => {
          if (hasDragged) {
            e.preventDefault();
            e.stopPropagation();
            hasDragged = false;
          }
        },
        true
      );
    }

    setupTouchSwipe() {
      const track = this.track;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let startTime = 0;
      let isHorizontal = false;
      let isSwiping = false;

      track.addEventListener(
        'touchstart',
        (e) => {
          if (e.touches.length !== 1) return;
          if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
          }
          this.stopAutoplay();

          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          startScrollLeft = track.scrollLeft;
          startTime = performance.now();
          isHorizontal = false;
          isSwiping = true;

          track.style.scrollSnapType = 'none';
          track.style.scrollBehavior = 'auto';
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        (e) => {
          if (!isSwiping || e.touches.length !== 1) return;
          const currentX = e.touches[0].clientX;
          const currentY = e.touches[0].clientY;
          const diffX = currentX - startX;
          const diffY = currentY - startY;

          if (!isHorizontal) {
            if (Math.abs(diffX) > 6 && Math.abs(diffX) > Math.abs(diffY)) {
              isHorizontal = true;
            } else if (Math.abs(diffY) > 8) {
              isSwiping = false;
              return;
            }
          }

          if (isHorizontal) {
            track.scrollLeft = startScrollLeft - diffX;
          }
        },
        { passive: true }
      );

      const endSwipe = (e) => {
        if (!isSwiping) return;
        isSwiping = false;

        if (isHorizontal) {
          const endX = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : startX;
          const diffX = endX - startX;
          const duration = Math.max(1, performance.now() - startTime);
          const velocity = diffX / duration; // px per ms

          const { stride, maxScroll } = this.getCardMetrics();
          const currentScroll = track.scrollLeft;

          let targetIndex;
          if (velocity < -0.22 || diffX < -stride * 0.18) {
            // Swiped forward
            targetIndex = Math.ceil((startScrollLeft + 10) / stride);
          } else if (velocity > 0.22 || diffX > stride * 0.18) {
            // Swiped backward
            targetIndex = Math.floor((startScrollLeft - 10) / stride);
          } else {
            // Soft release -> snap nearest
            targetIndex = Math.round(currentScroll / stride);
          }

          const targetScroll = Math.max(0, Math.min(targetIndex * stride, maxScroll));
          // Luxurious sluggish glide
          this.smoothScrollTo(targetScroll, 880);
        } else {
          track.style.scrollSnapType = '';
        }

        this.restartAutoplay();
      };

      track.addEventListener('touchend', endSwipe, { passive: true });
      track.addEventListener('touchcancel', endSwipe, { passive: true });
    }

    scroll(direction) {
      const { stride, maxScroll } = this.getCardMetrics();
      if (stride <= 0 || maxScroll <= 0) return;

      const currentScroll = this.track.scrollLeft;
      let targetScroll;

      if (direction === 1) {
        // Autoplay advance or next button click
        if (currentScroll >= maxScroll - 15) {
          targetScroll = 0; // Sluggishly glide back to beginning
        } else {
          const nextIndex = Math.floor((currentScroll + 15) / stride) + 1;
          targetScroll = Math.min(nextIndex * stride, maxScroll);
        }
      } else {
        if (currentScroll <= 15) {
          targetScroll = maxScroll;
        } else {
          const prevIndex = Math.ceil((currentScroll - 15) / stride) - 1;
          targetScroll = Math.max(0, prevIndex * stride);
        }
      }

      // 950ms luxurious sluggish glide for autoplay and button clicks
      this.smoothScrollTo(targetScroll, 950);
    }

    startAutoplay() {
      if (!this.enableAutoplay) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        const { maxScroll } = this.getCardMetrics();
        if (maxScroll > 0) {
          this.scroll(1);
        }
      }, this.autoplayInterval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    restartAutoplay() {
      this.stopAutoplay();
      setTimeout(() => this.startAutoplay(), 1800);
    }

    setupDots() {
      if (!this.dotsContainer) return;
      const { stride, totalItems } = this.getCardMetrics();
      if (totalItems <= 1) {
        this.dotsContainer.innerHTML = '';
        this.dots = [];
        return;
      }

      const firstItem = this.track.querySelector('[data-slider-item]');
      const cardWidth = firstItem ? firstItem.offsetWidth : 300;
      const visibleCount = Math.max(1, Math.round(this.track.clientWidth / cardWidth));
      const pagesCount = Math.max(1, totalItems - visibleCount + 1);

      this.dotsContainer.innerHTML = '';
      this.dots = [];

      for (let i = 0; i < pagesCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = `fc-dot ${i === 0 ? 'is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to saree slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this.smoothScrollTo(i * stride, 900);
          this.restartAutoplay();
        });
        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      }
    }

    updateDots() {
      if (!this.dots || !this.dots.length) return;
      const { stride } = this.getCardMetrics();
      if (stride <= 0) return;
      const activeIndex = Math.min(this.dots.length - 1, Math.max(0, Math.round(this.track.scrollLeft / stride)));
      this.dots.forEach((dot, idx) => {
        dot.classList.toggle('is-active', idx === activeIndex);
      });
    }

    handleScroll() {
      if (this.prevBtn && this.nextBtn) {
        const isAtStart = this.track.scrollLeft <= 5;
        const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 5;

        this.prevBtn.disabled = isAtStart;
        this.nextBtn.disabled = isAtEnd;

        // Nothing to scroll (e.g. fewer products than columns): hide the arrows entirely
        const canScroll = this.track.scrollWidth - this.track.clientWidth > 5;
        this.prevBtn.hidden = !canScroll;
        this.nextBtn.hidden = !canScroll;
      }
      this.updateDots();
    }
  }

  function initFeaturedCollections() {
    document.querySelectorAll('.featured-collection-section').forEach((section) => {
      new FeaturedCollectionSlider(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollections);
  } else {
    initFeaturedCollections();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('featured-collection-section')) {
      new FeaturedCollectionSlider(e.target);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ─── Mobile Drawer Controller ───────────────────────────
    function initMobileDrawer() {
      const drawer = document.getElementById('MobileDrawer');
      const overlay = document.getElementById('DrawerOverlay');

      if (!drawer || !overlay) return;

      // Teleport drawer and overlay to <body> to avoid any parent containing block/transform clipping
      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }
      if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }

      function openDrawer(e) {
        if (e && e.preventDefault) e.preventDefault();
        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        const hamburger = document.getElementById('HeaderHamburger');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('drawer-open');
        drawer.focus();
      }

      function closeDrawer(e) {
        if (e && e.preventDefault) e.preventDefault();
        drawer.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('aria-hidden', 'true');
        const hamburger = document.getElementById('HeaderHamburger');
        if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('drawer-open');
        if (hamburger) hamburger.focus();
      }

      // Expose globally for any programmatic triggers
      window.openMobileDrawer = openDrawer;
      window.closeMobileDrawer = closeDrawer;
    }

    initMobileDrawer();

    // Document-level event delegation for hamburger, close, overlay, and nav items
    document.addEventListener('click', function (e) {
      const hamburger = e.target.closest('#HeaderHamburger, .header__hamburger');
      if (hamburger) {
        if (window.openMobileDrawer) window.openMobileDrawer(e);
        return;
      }

      const closeBtn = e.target.closest('#DrawerClose, .mobile-drawer__close');
      if (closeBtn) {
        if (window.closeMobileDrawer) window.closeMobileDrawer(e);
        return;
      }

      if (e.target.id === 'DrawerOverlay' || e.target.classList.contains('drawer-overlay')) {
        if (window.closeMobileDrawer) window.closeMobileDrawer(e);
        return;
      }

      const navLink = e.target.closest('.mobile-drawer__nav-item, .mobile-chip');
      if (navLink) {
        if (window.closeMobileDrawer) window.closeMobileDrawer();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      const drawer = document.getElementById('MobileDrawer');
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
        if (window.closeMobileDrawer) window.closeMobileDrawer();
      }
    });

    // Ensure desktop nav is hidden on mobile (CSS fallback via JS)
    var desktopNav = document.getElementById('HeaderDesktopNav');
    function applyNavVisibility() {
      if (!desktopNav) return;
      if (window.innerWidth <= 768) {
        desktopNav.style.display = 'none';
      } else {
        desktopNav.style.display = '';
      }
    }
    applyNavVisibility();
    window.addEventListener('resize', applyNavVisibility);

    // ─── Animated Rotating Announcement Bar ─────────────────
    function initAnnouncementBar() {
      const bar = document.querySelector('[data-announcement-bar]');
      if (!bar) return;

      const slides = Array.from(bar.querySelectorAll('[data-announcement-slide]'));
      if (!slides.length) return;

      if (slides.length <= 1) {
        if (slides[0]) slides[0].classList.add('is-active');
        return;
      }

      const prevBtn = bar.querySelector('[data-announcement-prev]');
      const nextBtn = bar.querySelector('[data-announcement-next]');
      const isAutoplay = bar.dataset.autoplay !== 'false';
      const speed = parseInt(bar.dataset.speed, 10) || 4000;

      let currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (currentIndex < 0) currentIndex = 0;
      slides.forEach((s, idx) => {
        s.classList.toggle('is-active', idx === currentIndex);
        s.classList.remove('is-leaving', 'is-leaving-reverse');
      });

      let timer = null;
      let isTransitioning = false;

      function goToSlide(nextIndex, direction) {
        direction = direction || 'next';
        if (isTransitioning || nextIndex === currentIndex) return;
        isTransitioning = true;

        const currentSlide = slides[currentIndex];
        const nextSlide = slides[nextIndex];

        slides.forEach((s) => {
          s.classList.remove('is-leaving', 'is-leaving-reverse');
        });

        if (direction === 'next') {
          currentSlide.classList.remove('is-active');
          currentSlide.classList.add('is-leaving');

          nextSlide.style.transform = 'translateY(8px)';
          void nextSlide.offsetWidth;
          nextSlide.classList.add('is-active');
          nextSlide.style.transform = '';
        } else {
          currentSlide.classList.remove('is-active');
          currentSlide.classList.add('is-leaving-reverse');

          nextSlide.style.transform = 'translateY(-8px)';
          void nextSlide.offsetWidth;
          nextSlide.classList.add('is-active');
          nextSlide.style.transform = '';
        }

        currentIndex = nextIndex;

        setTimeout(() => {
          currentSlide.classList.remove('is-leaving', 'is-leaving-reverse');
          isTransitioning = false;
        }, 400);
      }

      function nextSlide() {
        const next = (currentIndex + 1) % slides.length;
        goToSlide(next, 'next');
      }

      function prevSlide() {
        const prev = (currentIndex - 1 + slides.length) % slides.length;
        goToSlide(prev, 'prev');
      }

      function startTimer() {
        if (!isAutoplay || slides.length <= 1) return;
        stopTimer();
        timer = setInterval(nextSlide, speed);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          nextSlide();
          startTimer();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          prevSlide();
          startTimer();
        });
      }

      bar.addEventListener('mouseenter', stopTimer);
      bar.addEventListener('mouseleave', startTimer);
      bar.addEventListener('touchstart', stopTimer, { passive: true });
      bar.addEventListener('touchend', startTimer, { passive: true });

      startTimer();

      // Shopify Theme Editor Live Update Listeners
      document.addEventListener('shopify:block:select', function (event) {
        if (!event.target || (!event.target.contains(bar) && event.target !== bar)) return;
        stopTimer();
        const targetBlockId = event.detail.blockId;
        const targetIndex = slides.findIndex((s) => s.dataset.blockId === targetBlockId);
        if (targetIndex >= 0) {
          goToSlide(targetIndex, 'next');
        }
      });

      document.addEventListener('shopify:block:deselect', function (event) {
        if (!event.target || (!event.target.contains(bar) && event.target !== bar)) return;
        startTimer();
      });
    }

    initAnnouncementBar();

    // ─── Sticky Header Scroll Controller ────────────────────────
    function initStickyHeader() {
      const header = document.getElementById('SiteHeader');
      if (!header) return;

      const headerGroup =
        header.closest('.shopify-section-group-header-group') ||
        header.closest('#shopify-section-group-header-group') ||
        header.closest('.shopify-section--header') ||
        header.closest('.shopify-section') ||
        header.parentElement;

      const stickyType = header.getAttribute('data-sticky-type') || 'always';

      function updateAnnouncementHeight() {
        const bar = header.querySelector('.header__announcement-bar') || document.querySelector('.header__announcement-bar');
        const height = (bar && bar.offsetHeight > 0) ? Math.ceil(bar.getBoundingClientRect().height) : 0;
        document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
        if (headerGroup) {
          if (height > 0) {
            headerGroup.classList.add('has-announcement-bar');
          } else {
            headerGroup.classList.remove('has-announcement-bar');
          }
          if (stickyType !== 'none') {
            headerGroup.style.top = `-${height}px`;
          }
        }
        return height;
      }

      const announcementHeight = updateAnnouncementHeight();

      if (stickyType === 'none') {
        if (headerGroup) {
          headerGroup.classList.remove(
            'is-sticky-group',
            'header-group--sticky-always',
            'header-group--on-scroll-up',
            'is-hidden',
            'is-visible'
          );
          headerGroup.classList.add('header-group--sticky-none');
          headerGroup.style.position = '';
          headerGroup.style.top = '';
          headerGroup.style.zIndex = '';
        }
        header.classList.remove('is-scrolled', 'is-hidden', 'is-visible');
        return;
      }

      // Activate sticky positioning on the top-level section group
      if (headerGroup) {
        headerGroup.classList.remove('header-group--sticky-none');
        headerGroup.classList.add('is-sticky-group');
        if (stickyType === 'always') {
          headerGroup.classList.add('header-group--sticky-always');
          headerGroup.classList.remove('header-group--on-scroll-up');
        } else if (stickyType === 'on-scroll-up') {
          headerGroup.classList.add('header-group--on-scroll-up');
          headerGroup.classList.remove('header-group--sticky-always');
        }
        headerGroup.style.position = 'sticky';
        headerGroup.style.top = `-${announcementHeight}px`;
        headerGroup.style.zIndex = '500';
      }

      let lastScrollY = Math.max(0, window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0);
      let isTicking = false;
      const scrollThreshold = Math.max(120, announcementHeight + 50); // Minimum scroll before hiding on scroll down

      function onScroll() {
        const currentScrollY = Math.max(0, window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0);
        const currentAnnounceH = (headerGroup && headerGroup.classList.contains('has-announcement-bar')) ? 
          (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 38) : 0;

        // 1. Elevated shadow on scroll (when main header reaches viewport top)
        if (currentScrollY > currentAnnounceH + 5) {
          header.classList.add('is-scrolled');
          if (headerGroup) headerGroup.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
          if (headerGroup) headerGroup.classList.remove('is-scrolled');
        }

        // 2. On-Scroll-Up reveal logic
        if (stickyType === 'on-scroll-up') {
          if (currentScrollY <= currentAnnounceH + 5) {
            header.classList.remove('is-hidden', 'is-visible');
            if (headerGroup) headerGroup.classList.remove('is-hidden', 'is-visible');
          } else if (currentScrollY > lastScrollY && currentScrollY > scrollThreshold) {
            // Scrolling down -> hide header smoothly
            header.classList.add('is-hidden');
            header.classList.remove('is-visible');
            if (headerGroup) {
              headerGroup.classList.add('is-hidden');
              headerGroup.classList.remove('is-visible');
            }
          } else if (currentScrollY < lastScrollY) {
            // Scrolling up -> reveal header smoothly
            header.classList.remove('is-hidden');
            header.classList.add('is-visible');
            if (headerGroup) {
              headerGroup.classList.remove('is-hidden');
              headerGroup.classList.add('is-visible');
            }
          }
        }

        lastScrollY = currentScrollY;
        isTicking = false;
      }

      window.addEventListener(
        'scroll',
        () => {
          if (!isTicking) {
            window.requestAnimationFrame(onScroll);
            isTicking = true;
          }
        },
        { passive: true }
      );

      window.addEventListener('resize', updateAnnouncementHeight, { passive: true });

      onScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initMobileDrawer();
        initStickyHeader();
      });
    } else {
      initMobileDrawer();
      initStickyHeader();
    }

    // Theme editor live preview support
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.querySelector('#SiteHeader') || e.target.id === 'SiteHeader') {
        initMobileDrawer();
        initStickyHeader();
      }
    });
    document.addEventListener('shopify:section:select', (e) => {
      if (e.target.querySelector('#SiteHeader') || e.target.id === 'SiteHeader') {
        initMobileDrawer();
        initStickyHeader();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.hero-slider__slide');
      this.dots = this.querySelectorAll('.hero-slider__dot');
      this.track = this.querySelector('[data-slider-track]');
      this.isSlideMode = this.classList.contains('hero-slider--slide');

      this.currentIndex = 0;
      this.totalSlides = this.slides.length;
      this.autoplay = this.dataset.autoplay === 'true';
      this.intervalDuration = parseInt(this.dataset.autoplayInterval, 10) || 5000;
      this.timer = null;

      if (this.totalSlides <= 1) return;

      this.initEvents();
      this.startAutoplay();
    }

    initEvents() {
      this.dots.forEach((dot, idx) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(idx);
          this.resetAutoplay();
        });
      });

      // Pause on hover
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());

      // Touch swipe support for mobile
      let touchStartX = 0;
      let touchEndX = 0;

      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        this.stopAutoplay();
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) {
            this.goTo(this.currentIndex + 1);
          } else {
            this.goTo(this.currentIndex - 1);
          }
        }
        this.startAutoplay();
      }, { passive: true });

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.goTo(this.currentIndex - 1);
          this.resetAutoplay();
        } else if (e.key === 'ArrowRight') {
          this.goTo(this.currentIndex + 1);
          this.resetAutoplay();
        }
      });
    }

    goTo(index) {
      if (index < 0) {
        this.currentIndex = this.totalSlides - 1;
      } else if (index >= this.totalSlides) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }

      this.updateState();
    }

    updateState() {
      this.slides.forEach((slide, idx) => {
        if (idx === this.currentIndex) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });

      if (this.isSlideMode && this.track) {
        this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      }

      this.dots.forEach((dot, idx) => {
        if (idx === this.currentIndex) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.setAttribute('aria-selected', 'false');
        }
      });
    }

    startAutoplay() {
      if (!this.autoplay || this.totalSlides <= 1) return;
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.intervalDuration);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSliderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const tabButtons = document.querySelectorAll('.luxury-tab-btn');
    tabButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const targetIndex = btn.getAttribute('data-tab-target');
        const sectionEl = btn.closest('.luxury-featured-collection-section');
        if (!sectionEl) return;

        // Deactivate all sibling buttons
        sectionEl.querySelectorAll('.luxury-tab-btn').forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        // Hide all panels, show active panel
        sectionEl.querySelectorAll('.luxury-tab-panel').forEach((panel) => {
          if (panel.getAttribute('data-panel-index') === targetIndex) {
            panel.classList.add('is-active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('is-active');
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function initProductSection() {
    // 1. Load Product JSON Data
    const productJsonScript = document.querySelector('script[data-product-json]');
    if (!productJsonScript) return;

    let product;
    try {
      product = JSON.parse(productJsonScript.textContent);
    } catch (e) {
      console.error('Error parsing product JSON', e);
      return;
    }

    const section = document.querySelector('[data-section-type="product"]');
    if (!section) return;

    // Toast helper
    const toast = document.querySelector('.product-toast');
    const showToast = (message) => {
      if (!toast) return;
      toast.querySelector('.product-toast__message').textContent = message;
      toast.classList.add('is-visible');
      setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 3000);
    };

    // 2. Mobile Carousel Scroll & Indicator Sync
    const mobileSlider = section.querySelector('[data-mobile-slider]');
    const mobileDots = section.querySelectorAll('.product-gallery__mobile-dot');
    const mobileCounter = section.querySelector('[data-mobile-current-index]');

    if (mobileSlider) {
      mobileSlider.addEventListener(
        'scroll',
        () => {
          const scrollLeft = mobileSlider.scrollLeft;
          const width = mobileSlider.offsetWidth;
          const activeIndex = Math.round(scrollLeft / width);

          if (mobileCounter) {
            mobileCounter.textContent = activeIndex + 1;
          }

          mobileDots.forEach((dot, idx) => {
            if (idx === activeIndex) {
              dot.classList.add('is-active');
              dot.setAttribute('aria-selected', 'true');
            } else {
              dot.classList.remove('is-active');
              dot.setAttribute('aria-selected', 'false');
            }
          });
        },
        { passive: true }
      );

      mobileDots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const targetIndex = parseInt(dot.getAttribute('data-slide-target'), 10);
          const slideWidth = mobileSlider.offsetWidth;
          mobileSlider.scrollTo({
            left: targetIndex * slideWidth,
            behavior: 'smooth',
          });
        });
      });
    }

    // 3. Desktop "Scroll Below" button
    const scrollBtn = section.querySelector('[data-scroll-to-next]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', () => {
        const desktopItems = section.querySelectorAll('.product-gallery__item');
        if (desktopItems.length > 1) {
          desktopItems[1].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // 4. Share Handler
    const shareBtn = section.querySelector('.product-share-toggle');
    if (shareBtn) {
      shareBtn.addEventListener('click', async () => {
        const title = shareBtn.getAttribute('data-share-title');
        const url = shareBtn.getAttribute('data-share-url') || window.location.href;

        if (navigator.share) {
          try {
            await navigator.share({ title: title, url: url });
          } catch (e) {}
        } else {
          try {
            await navigator.clipboard.writeText(url);
            showToast('Product link copied to clipboard!');
          } catch (err) {
            showToast('Share: ' + url);
          }
        }
      });
    }

    // 5. Variant Selection Logic
    const variantIdInput = section.querySelector('[data-selected-variant-id]');
    const priceDisplay = section.querySelector('[data-product-price]');
    const comparePriceDisplay = section.querySelector('[data-product-compare-price]');
    const discountBadge = section.querySelector('[data-product-discount-badge]');
    const skuDisplay = section.querySelector('[data-product-sku]');
    const addBagBtns = section.querySelectorAll('[data-add-to-bag]');
    const buyNowBtns = section.querySelectorAll('[data-buy-now]');
    const optionInputs = section.querySelectorAll('.product-option-input');

    const formatMoney = (cents) => {
      const amount = (cents / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return '₹ ' + amount;
    };

    const onOptionChange = () => {
      const selectedOptions = [];
      const optionGroups = section.querySelectorAll('.product-option-group[data-option-index]');

      optionGroups.forEach((group) => {
        const checkedInput = group.querySelector('.product-option-input:checked');
        if (checkedInput) {
          selectedOptions.push(checkedInput.value);
          const label = group.querySelector('[data-option-selected-label]');
          if (label) label.textContent = checkedInput.value;
        }
      });

      const matchedVariant = product.variants.find((variant) => {
        return variant.options.every((optValue, idx) => {
          return selectedOptions[idx] === undefined || selectedOptions[idx] === optValue;
        });
      });

      if (matchedVariant) {
        if (variantIdInput) variantIdInput.value = matchedVariant.id;

        const skuWrappers = section.querySelectorAll('[data-product-sku-wrapper]');
        if (skuDisplay) {
          if (matchedVariant.sku && matchedVariant.sku.trim() !== '') {
            skuDisplay.textContent = matchedVariant.sku;
            skuWrappers.forEach((wrapper) => {
              wrapper.style.display = '';
            });
          } else {
            skuDisplay.textContent = '';
            skuWrappers.forEach((wrapper) => {
              wrapper.style.display = 'none';
            });
          }
        }

        if (priceDisplay) priceDisplay.textContent = formatMoney(matchedVariant.price);

        if (comparePriceDisplay) {
          if (matchedVariant.compare_at_price > matchedVariant.price) {
            comparePriceDisplay.textContent = formatMoney(matchedVariant.compare_at_price);
            comparePriceDisplay.classList.remove('is-hidden');

            if (discountBadge) {
              const diff = matchedVariant.compare_at_price - matchedVariant.price;
              const pct = Math.round((diff * 100) / matchedVariant.compare_at_price);
              discountBadge.textContent = `(${pct}% OFF)`;
              discountBadge.classList.remove('is-hidden');
            }
          } else {
            comparePriceDisplay.classList.add('is-hidden');
            if (discountBadge) discountBadge.classList.add('is-hidden');
          }
        }

        addBagBtns.forEach((btn) => {
          const btnText = btn.querySelector('.product-btn__text');
          if (matchedVariant.available) {
            btn.removeAttribute('disabled');
            if (btnText) btnText.textContent = btn.getAttribute('data-original-text') || 'Add to cart';
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (btnText) btnText.textContent = 'SOLD OUT';
          }
        });

        buyNowBtns.forEach((btn) => {
          const btnText = btn.querySelector('.product-btn__text');
          if (matchedVariant.available) {
            btn.removeAttribute('disabled');
            if (btnText) btnText.textContent = btn.getAttribute('data-original-text') || 'Buy now';
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (btnText) btnText.textContent = 'SOLD OUT';
          }
        });

        const qtyInputs = section.querySelectorAll('[data-product-qty-input]');
        const qtyButtons = section.querySelectorAll('[data-product-qty-btn]');
        qtyInputs.forEach((input) => {
          if (matchedVariant.available) {
            input.removeAttribute('disabled');
          } else {
            input.setAttribute('disabled', 'disabled');
          }
        });
        qtyButtons.forEach((btn) => {
          if (matchedVariant.available) {
            btn.removeAttribute('disabled');
          } else {
            btn.setAttribute('disabled', 'disabled');
          }
        });

        if (matchedVariant.featured_image && matchedVariant.featured_image.id) {
          const mediaEl = document.getElementById('ProductMedia-' + matchedVariant.featured_image.id);
          if (mediaEl && window.innerWidth >= 992) {
            mediaEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        if (history.replaceState) {
          const newUrl = window.location.pathname + '?variant=' + matchedVariant.id;
          window.history.replaceState({ path: newUrl }, '', newUrl);
        }
      }
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', onOptionChange);
    });

    // Color variant swatch card trigger handler
    const colorVariantTriggers = section.querySelectorAll('[data-color-variant-trigger]');
    colorVariantTriggers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const pos = btn.getAttribute('data-option-position');
        const val = btn.getAttribute('data-option-value');
        const radio = section.querySelector(`input[name="option-${pos}"][value="${val}"]`);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        colorVariantTriggers.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    // Pincode Estimator
    const pincodeInput = section.querySelector('[data-pincode-input]');
    const pincodeCheckBtn = section.querySelector('[data-pincode-check-btn]');
    const pincodeStatus = section.querySelector('[data-pincode-status]');

    const checkPincode = () => {
      if (!pincodeInput || !pincodeStatus) return;
      const code = pincodeInput.value.trim();
      const isValid = /^[1-9][0-9]{5}$/.test(code);

      if (isValid) {
        pincodeStatus.className = 'product-pincode-checker__status is-success';
        pincodeStatus.innerHTML = `<p class="product-pincode-checker__estimate">✓ Delivery available to <strong>${code}</strong> within 4 - 8 business days</p>`;
      } else {
        pincodeStatus.className = 'product-pincode-checker__status is-error';
        pincodeStatus.innerHTML = `<p class="product-pincode-checker__estimate">Please enter a valid 6-digit Indian PIN code</p>`;
      }
    };

    if (pincodeCheckBtn) {
      pincodeCheckBtn.addEventListener('click', checkPincode);
    }
    if (pincodeInput) {
      pincodeInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          checkPincode();
        }
      });
    }

    // Collapsible Accordions
    const accordionHeaders = section.querySelectorAll('[data-accordion-toggle]');
    accordionHeaders.forEach((header) => {
      header.addEventListener('click', () => {
        const item = header.closest('[data-accordion-item]');
        const content = item.querySelector('[data-accordion-content]');
        const isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open', !isOpen);
        header.setAttribute('aria-expanded', String(!isOpen));
        if (!content) return;

        // Animate between 0 and the content's natural height, then hand back to auto/none
        content.removeEventListener('transitionend', content._accordionDone);
        if (isOpen) {
          content.style.height = `${content.scrollHeight}px`;
          content.offsetHeight; // commit start height before animating
          content.style.height = '0px';
          content.style.opacity = '0';
          content._accordionDone = (e) => {
            if (e.propertyName !== 'height') return;
            content.style.display = 'none';
          };
        } else {
          content.style.display = 'block';
          content.style.height = '0px';
          content.style.opacity = '0';
          content.offsetHeight;
          content.style.height = `${content.scrollHeight}px`;
          content.style.opacity = '1';
          content._accordionDone = (e) => {
            if (e.propertyName !== 'height') return;
            content.style.height = '';
          };
        }
        content.addEventListener('transitionend', content._accordionDone);

        // Reduced motion: no transition fires, so finish immediately
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          content._accordionDone({ propertyName: 'height' });
        }
      });
    });

    // Sticky info panel: when the panel is taller than the viewport, stick it by its bottom edge
    // so the whole panel scrolls into view with the page instead of being clipped.
    const infoPanel = section.querySelector('.product-info-panel');
    if (infoPanel) {
      const updateStickyTop = () => {
        const gap = 24;
        const top = Math.min(gap, window.innerHeight - infoPanel.offsetHeight - gap);
        infoPanel.style.setProperty('--product-info-sticky-top', `${top}px`);
      };
      updateStickyTop();
      window.addEventListener('resize', updateStickyTop);
      if ('ResizeObserver' in window) new ResizeObserver(updateStickyTop).observe(infoPanel);
    }

    // Size Guide Modal
    const sizeGuideTriggers = section.querySelectorAll('[data-size-guide-trigger]');
    const sizeGuideModal = document.querySelector('.product-size-guide-modal');
    const sizeGuideClose = document.querySelector('[data-size-guide-close]');

    if (sizeGuideModal) {
      sizeGuideTriggers.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (typeof sizeGuideModal.showModal === 'function') {
            sizeGuideModal.showModal();
          } else {
            sizeGuideModal.setAttribute('open', '');
          }
        });
      });

      if (sizeGuideClose) {
        sizeGuideClose.addEventListener('click', () => {
          if (typeof sizeGuideModal.close === 'function') {
            sizeGuideModal.close();
          } else {
            sizeGuideModal.removeAttribute('open');
          }
        });
      }

      sizeGuideModal.addEventListener('click', (e) => {
        if (e.target === sizeGuideModal) {
          if (typeof sizeGuideModal.close === 'function') {
            sizeGuideModal.close();
          } else {
            sizeGuideModal.removeAttribute('open');
          }
        }
      });
    }

    // Mobile Bottom Navigation Offset Sync
    const syncMobileNavOffset = () => {
      const mobileNav = document.querySelector('.mobile-bottom-nav');
      if (mobileNav && window.innerWidth <= 768) {
        const height = mobileNav.offsetHeight;
        if (height > 0) {
          document.documentElement.style.setProperty('--mobile-nav-height', `${height}px`);
        }
      }
    };
    syncMobileNavOffset();
    window.addEventListener('resize', syncMobileNavOffset);
  }

  // Global Delegated Quantity Stepper Handler
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-product-qty-btn]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const stepper = btn.closest('[data-product-qty-wrapper]') || btn.closest('.product-qty-stepper');
    const input = stepper
      ? stepper.querySelector('[data-product-qty-input]')
      : document.querySelector('[data-product-qty-input]');
    if (!input || input.disabled) return;

    const action = btn.getAttribute('data-product-qty-btn');
    let currentVal = parseInt(input.value, 10) || 1;
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const max = parseInt(input.getAttribute('max'), 10) || 99;

    if (action === 'minus') {
      currentVal = Math.max(min, currentVal - 1);
    } else if (action === 'plus') {
      currentVal = Math.min(max, currentVal + 1);
    }

    // Synchronize all quantity inputs on the page
    document.querySelectorAll('[data-product-qty-input]').forEach((el) => {
      el.value = currentVal;
      el.dispatchEvent(new Event('change', { bubbles: true }));
      el.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  // Quantity Manual Input Sanitizer & Sync
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-product-qty-input]');
    if (!input) return;
    let val = parseInt(input.value, 10);
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const max = parseInt(input.getAttribute('max'), 10) || 99;

    if (isNaN(val) || val < min) val = min;
    if (val > max) val = max;
    input.value = val;

    document.querySelectorAll('[data-product-qty-input]').forEach((el) => {
      if (el !== input) el.value = val;
    });
  });

  // Global Delegated Add to Cart (Bag) Handler
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-bag]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const section = btn.closest('[data-section-type="product"]') || document;
    const variantInput =
      section.querySelector('[data-selected-variant-id]') || document.querySelector('[data-selected-variant-id]');
    let variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      const prodJsonScript = document.querySelector('script[data-product-json]');
      if (prodJsonScript) {
        try {
          const prodData = JSON.parse(prodJsonScript.textContent);
          if (prodData && prodData.variants && prodData.variants.length > 0) {
            variantId = prodData.variants[0].id;
          }
        } catch (err) {}
      }
    }

    if (!variantId) {
      console.warn('Could not determine variant ID for Add to Cart');
      return;
    }

    const qtyInput =
      section.querySelector('[data-product-qty-input]') || document.querySelector('[data-product-qty-input]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    // Toast helper
    const toast = document.querySelector('.product-toast');
    const showToast = (message) => {
      if (!toast) return;
      toast.querySelector('.product-toast__message').textContent = message;
      toast.classList.add('is-visible');
      setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 3000);
    };

    btn.classList.add('is-loading');
    btn.setAttribute('disabled', 'disabled');

    try {
      if (window.CartDrawer && typeof window.CartDrawer.addItem === 'function') {
        await window.CartDrawer.addItem(variantId, quantity);
        showToast(quantity > 1 ? `${quantity} items added to your bag!` : 'Item added to your bag!');
      } else {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          showToast(quantity > 1 ? `${quantity} items added to your bag!` : 'Item added to your bag!');

          if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
            await window.CartDrawer.refresh();
            window.CartDrawer.open();
          } else {
            try {
              const cartRes = await fetch('/cart.js');
              const cartData = await cartRes.json();
              const newCount = cartData.item_count;

              document.querySelectorAll('.header__cart-badge, .mobile-drawer__cart-counter').forEach((badge) => {
                badge.textContent = newCount;
                badge.style.display = newCount > 0 ? '' : 'none';
              });
            } catch (err) {}
          }
        } else {
          showToast(data.description || 'Could not add item to bag');
        }
      }
    } catch (err) {
      console.error('Error adding to cart:', err);
      showToast('Item added to bag');
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('disabled');
    }
  });

  // Global Delegated Buy Now Handler
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const section = btn.closest('[data-section-type="product"]') || document;
    const variantInput =
      section.querySelector('[data-selected-variant-id]') || document.querySelector('[data-selected-variant-id]');
    let variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      const prodJsonScript = document.querySelector('script[data-product-json]');
      if (prodJsonScript) {
        try {
          const prodData = JSON.parse(prodJsonScript.textContent);
          if (prodData && prodData.variants && prodData.variants.length > 0) {
            variantId = prodData.variants[0].id;
          }
        } catch (err) {}
      }
    }

    if (!variantId) return;

    const qtyInput =
      section.querySelector('[data-product-qty-input]') || document.querySelector('[data-product-qty-input]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    // window.location.href = `/cart/${variantId}:${quantity}`;
    if (typeof window.onBuyNowClick === 'function') {
      try {
        window.onBuyNowClick(e, false, [{ id: variantId, quantity: quantity }]);
        return;
      } catch (err) {
        console.error('[Main Pdp] GoKwik error:', err);
      }
    }
  });

  // Execute initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSection);
  } else {
    initProductSection();
  }
  document.addEventListener('shopify:section:load', initProductSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  function initProductRecommendations() {
    const section = document.querySelector('[data-section-type="related-products"]');
    if (!section) return;

    const url = section.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendationsGrid = html.querySelector('[data-recommendations-grid]');
        const currentGrid = section.querySelector('[data-recommendations-grid]');

        if (recommendationsGrid && currentGrid && recommendationsGrid.children.length > 0) {
          currentGrid.innerHTML = recommendationsGrid.innerHTML;
        }
      })
      .catch((e) => {
        console.warn('Could not load dynamic recommendations', e);
      });
  }

  // Delegated Buy Now for Related Product Cards
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-related-buy-now]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // window.location.href = `/cart/${variantId}:1`;
    if (typeof window.onBuyNowClick === 'function') {
              try {
                window.onBuyNowClick(e, false, [{ id: variantId, quantity: 1 }]);
                return;
              } catch (err) {
                console.error('[Related Product] GoKwik error:', err);
              }
            }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductRecommendations);
  } else {
    initProductRecommendations();
  }
  document.addEventListener('shopify:section:load', initProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
